import { cn } from '@utils';
import { cva, type VariantProps } from 'class-variance-authority';

const headingVariants = cva('font-bold tracking-tight', {
	variants: {
		as: {
			h1: 'text-4xl lg:text-5xl',
			h2: 'text-3xl lg:text-4xl',
			h3: 'text-2xl lg:text-3xl',
			h4: 'text-xl lg:text-2xl',
			h5: 'text-lg lg:text-xl',
			h6: 'text-base lg:text-lg',
		},
		color: {
			primary: 'text-textPrimary',
			darkGray: 'text-textDarkGray',
			mediumGray: 'text-textMediumGray',
			black: 'text-textBlack',
		},
	},
	defaultVariants: {
		as: 'h4',
	},
});

type HeadingProps = Omit<React.HTMLAttributes<HTMLHeadingElement>, 'color'> & VariantProps<typeof headingVariants>;

function Heading({ className, color, as, children, ...props }: HeadingProps) {
	const Tag = as ?? 'h4';

	return (
		<Tag className={cn(headingVariants({ as, color, className }))} data-testid={`heading-${as}`} {...props}>
			{children}
		</Tag>
	);
}

Heading.displayName = 'Heading';

export { Heading };

export type { HeadingProps };
